import React from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { ProgramBadge } from './program-badge';
import { VodBadge } from './vod-badge';

interface DetailsBadgeProps {
  asset: Asset;
  source: Source;
}

export function DetailsBadge({ asset, source }: DetailsBadgeProps) {
  switch (source.type) {
    case 'program':
      return <ProgramBadge asset={asset} source={source} />;
    case 'vod':
      return <VodBadge source={source} />;
    default:
      return null;
  }
}
